import * as React from "react"
import { SVGProps, memo } from "react"

const Copy = memo((props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        {...props}
    >
        <path
            d="M10.667 2H12.667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V13.3333C14 13.687 13.8595 14.0261 13.6095 14.2761C13.3594 14.5262 13.0203 14.6667 12.667 14.6667H10.667M7.33333 11.3333L10.6667 8L7.33333 4.66667M10.6667 8H2"
            stroke="#364960"
        />
    </svg>
))

export default Copy